import { ApiOptions, OrgId } from '@csp/csp-common-model';
import { OrgSchedulesMapper, OrgsSchedules } from '@csp/csp-common-scheduling';
import { toRestOptions } from '@csp/csp-fe-auth';
import { ConsentRestServiceV1 } from '@csp/dmdp-api-client';
import { ConsentRequest } from '../model/ConsentRequest';
import { ConsentSchedule } from '../model/ConsentSchedule';

const getActiveSchedules = async (orgId?: OrgId, apiOptions?: ApiOptions): Promise<ConsentSchedule[]> => {
  if (!orgId) {
    return [];
  }

  const activeSchedules = await ConsentRestServiceV1.getActiveSchedulesByOrgId(toRestOptions(apiOptions), orgId);

  return activeSchedules ? activeSchedules.activeSchedules.map(ConsentSchedule.from) : [];
};

const getActivedSchedulesForOrgIds = async (
  orgIds?: OrgId[],
  apiOptions?: ApiOptions,
): Promise<OrgsSchedules<ConsentSchedule, ConsentRequest>> => {
  if (!orgIds) {
    return OrgsSchedules.from([]);
  }

  const activeSchedules = await ConsentRestServiceV1.queryActivatedSchedulesByOrgIds(toRestOptions(apiOptions), {
    orgIds,
  });

  return OrgsSchedules.from<ConsentSchedule, ConsentRequest>(
    OrgSchedulesMapper.fromV1s(activeSchedules, ConsentSchedule.from),
  );
};

export const ConsentScheduleService = {
  getActiveSchedules,
  getActivedSchedulesForOrgIds,
};
